import { Box } from '@mui/material';

const Wrapper = ({
  children,
  sx = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mt: '2rem',
    mb: '0.5rem',
  },
}) => {
  return <Box sx={sx}>{children}</Box>;
};

export default Wrapper;
